module.exports = __webpack_public_path__ + "img/40_69_000_100.1af653ab.jpg";